export const comments_5129912 = {"data":{"data":[],"links":{}}}